<template>
  <li>
    <div class="content-details">
      <div class="content-area-title">
        <div class="area-title" @click="areaSelect(responsibilityAreaData)">
          {{ responsibilityAreaData.zqName }}
        </div>
        <div
          class="area-tip"
          v-if="responsibilityAreaData.isNextLevel"
          @click="toggle(responsibilityAreaData)"
        >
          {{ isOpen ? "收起" : "展开" }}
        </div>
      </div>
    </div>
    <ul v-show="isOpen" v-if="isFolder">
      <!-- 重点代码，调用自身，实现递归，绑定数据 -->
      <zrqarea-Item
        v-for="(item, index) in responsibilityAreaData.children"
        :zrqData="item"
        :key="item.zqName + index"
        @getMapOptions="setMapOptions"
      ></zrqarea-Item>
    </ul>
  </li>
</template>
<!--eslint-disable-->
<script>
import { mapState } from "vuex";
export default {
  name: "zrqarea-Item",
  // 如果想使用此组件，则需要传递的数据
  props: {
    zrqData: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
    objValue: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
    isParentOpen:{
      type: Boolean,
      default: false,
    },//第一层展开
  },

  data() {
    return {
      // 默认不显示下级目录
      isOpen: false,
      responsibilityAreaData: { children: [] },
      selectObjid: "", //
      isEmpty: true, //数据为空
    };
  },
  mounted() {
    this.isOpen=this.isParentOpen;
    if (this.zrqData && this.zrqData.zqName) {
      this.responsibilityAreaData = Object.assign({}, this.zrqData);
    }
  },
  created() {},
  methods: {
    // 点击折叠展开的方法
    async toggle(obj) {
      if (!obj.loading) {
        //未加载，需要去加载
        // this.searchValue.zqCode
        console.log(obj, "obj");
        console.log(this.objValue, "searchValue");
        this.objValue.zqCode = obj.zqCode;
        this.objValue.gridType = obj.type;
        this.objValue.objid = obj.objid;
        let children = await this.getResponsibilityAreaData(this.objValue);
        this.$set(obj, "loading", true);
        this.$set(obj, "children", children.children);
      }
      this.isOpen = !this.isOpen;
    },
    //获取列表数据
    async getResponsibilityAreaData(zqCode) {
      var _this = this;
      // var param = {
      //   zqCode: zqCode,
      // };

      return await new Promise((resolve) => {
        _this.$api.search
          .resourceZqAndZrqTree(this.objValue)
          .then((res) => {
            if (res.code == 1) {
              resolve(res.data);
            } else {
              _this.$Message.error(res.msg);
            }
          })
          .catch((err) => {
            _this.$Message.error(err);
          });
      });
    },
    areaSelect(item) {
      //点击查看相关责任区详细信息
      this.selectObjid = item.objid;
      this.$emit("getMapOptions", item);
    },
    setMapOptions(item) {
      this.$emit("getMapOptions", item);
    },
  },
  computed: {
    ...mapState("user", ["userinfo"]),
    // ...mapState(["gis_objid"]),
    // 控制是否有下级目录和显示下级目录
    isFolder() {
      return (
        this.responsibilityAreaData.children &&
        this.responsibilityAreaData.children.length
      );
    },
  },
  watch: {
    zrqData: {
      handler: function () {
        if (this.zrqData && this.zrqData.zqName) {
          this.responsibilityAreaData = Object.assign({}, this.zrqData);
        }
      },
      deep: true,
    },
    objValue: {
      handler: function () {
        console.log(this.objValue, "this.searchValue");
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
.content-details {
  overflow: hidden;
  width: 100%;
  height: auto;
  padding: 10px 10px;
  margin: 10px 0;
  border-radius: 10px;
  background: #fff;
  border-radius: 5px;
}
.content-area-title {
  display: flex;
  .area-title {
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    color: #636464;
    font-size: 16px;
    font-weight: 600;
  }
  .area-tip {
    padding-left: 10px;
    flex-shrink: 0;
    font-size: 12px;
    font-weight: 500;
    padding: 3px 10px;
    background-color: rgba(240, 239, 239, 0.6);
    color: #636464;
  }
}
.mapdrawer .cuSelect {
  color: #00cba6;
}
// @import './gis-resourceStyle.scss';
</style>